import { register } from 'backend/submitTicket';
// import * as bi from 'public/bi';
var country_list = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];
export default function escapeHtml(str) {
	return str
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}

function checkValidityPage1() {

	//var urlReg = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)(\w*\.)+\w\w*/;
	//var urlReg = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)(\w*\.)+\w\w*/;
	//var urlReg = /(http(s)?:\/\/.)?(www\.)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.)?[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)(\w*\.)+\w\w*/;
	//var ownerUrlValid = urlReg.test($w('#ownerUrlInput').value.trim().toLowerCase());
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	var emailValid = re.test($w('#emailInput').value.trim());
	if ($w('#addtlPhoneInput').value !== '' && !$w('#addtlPhoneInput').valid) {
		return false;
	}

	$w('#text34').hide();
	if ($w('#ownerUrlInput').value.trim() === '') {
		$w('#text108').show();
		return false;
	}
	if (!emailValid) {
		$w('#text34').text = 'Please enter a valid Email address';
		$w('#text34').show();
		return false;
	}

	if ($w('#emailInput').value.trim().toLowerCase() !== $w('#confirmEmailInput').value.trim().toLowerCase()) {
		$w('#text34').text = 'The emails do not match';
		$w('#text34').show();
		return false;
	}

	return $w('#ownerNameInput').valid && $w('#firstNameInput').valid && $w('#lastNameInput').valid && emailValid && $w('#addressInput').valid && $w('#telephoneInput').valid;
}

function checkValidityPage2() {

	return $w('#tmDescrInput').valid && $w('#registeredRadio').valid;
}

function checkValidityPage3() {
	$w('#text102').hide();
	$w('#text103').hide();
	//var urlReg = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)(\w*\.)+\w\w*/;
	//var urlReg = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)(\w*\.)+\w\w*/;
	//  var urlReg = /(http(s)?:\/\/.)?(www\.)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.)?[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)(\w*\.)+\w\w*/;
//	var registrUrlValid = urlReg.test($w('#registUrlInput').value.trim().toLowerCase());
//	var infringingUrlValid = urlReg.test($w('#infringingUrlInput').value.trim().toLowerCase());

	if ($w('#registUrlInput').value.trim() === '') {
		$w('#text102').show();
		return false;
	}
	if ($w('#infringingUrlInput').value.trim() === '') {
		$w('#text103').show();
		return false;
	}

	return $w('#tmDescrInput').valid && $w('#registeredRadio').valid && $w('#countrySelect').valid &&  $w('#infringementDescrInput').valid &&
		$w('#registNumInput').valid && $w('#trademarkInfoInput').valid;
}

function checkValidityPage4() {
	return $w('#checkbox4').checked && $w('#checkbox7').checked && $w('#signatureInput').valid;
}

export function authorizationRadioOnChange(event) {
	if ($w('#authorizationRadio').selectedIndex == 0) {
		$w('#text36').collapse();
		$w('#text107').collapse();
		$w('#stripOne').expand();
		$w('#text104').show();
		$w('#text104').expand();

	} else {
		$w('#text36').expand();
		$w('#stripOne').collapse();
		$w('#text107').expand();
		$w('#text104').collapse();
	}
}

export function nextButton1OnClick(event) {
	$w('#text108').hide();
	$w('#text34').hide();
	$w('#text35').hide();
	if (checkValidityPage1()) {
		$w('#text35').hide();
		$w('#stripOne').collapse();
		$w('#authorizationGroup').collapse();
		$w('#stripTwo').expand();
		$w('#text105').collapse();

		$w("#authorizationGroup").scrollTo();
	} else {
		$w('#text35').show();

		///	$w("#nextBtn1").link = null;
		//	console.log($w("#nextBtn1").link )

		//
		$w('#text35').expand();
	}

}

export function registeredRadioOnChange(event) {
	if ($w('#registeredRadio').selectedIndex == 0) {
		$w('#text66').collapse();
		$w('#backBtn1').show();
		$w('#nextBtn2').show();
		$w('#backBtn1').expand();
		$w('#nextBtn2').expand();
		$w('#text50').expand();

	} else {
		$w('#text66').expand();
		$w('#backBtn1').hide();
		$w('#nextBtn2').hide();
		$w('#text50').hide();
		$w('#backBtn1').collapse();
		$w('#nextBtn2').collapse();
		$w('#text50').collapse();

	}
}

export function nextButton2OnClick(event) {
	if (checkValidityPage2()) {
		$w('#text50').hide();
		$w('#stripTwo').collapse();
		$w('#text105').collapse();
		$w('#stripThree').expand();
		$w("#authorizationGroup").scrollTo();
	} else {
		$w('#text50').show();
	}

}

export function backButton1OnClick(event) {
	$w('#stripTwo').collapse();
	$w('#stripOne').expand();
	$w('#text105').expand();
	$w('#text50').hide();
	$w('#text104').show();
	$w('#authorizationGroup').expand();
	$w("#authorizationGroup").scrollTo();
}

export function backButton2OnClick(event) {
	$w('#text102').hide();
	$w('#text103').hide();
	$w('#stripThree').collapse();
	$w('#stripTwo').expand();
	$w('#text76').hide();
	$w("#authorizationGroup").scrollTo();
}

export function nextButton3OnClick(event) {
	if (checkValidityPage3()) {
		$w('#text76').hide();
		$w('#stripThree').collapse();
		$w('#text105').collapse();
		$w('#stripFour').expand();
		$w("#authorizationGroup").scrollTo();
	} else {
		$w('#text76').show();
	}
}

export function backButton3OnClick(event) {
	$w('#stripFour').collapse();
	$w('#stripThree').expand();
	$w('#text77').hide()
	$w("#authorizationGroup").scrollTo();
}

function submit(documentUrls) {
	let ownerName = escapeHtml($w('#ownerNameInput').value);
	let orgOrClient = escapeHtml($w('#orgClientInput').value);
	let firstName = escapeHtml($w('#firstNameInput').value);
	let lastName = escapeHtml($w('#lastNameInput').value);
	let ownerUrl = escapeHtml($w('#ownerUrlInput').value);
	let email = escapeHtml($w('#emailInput').value);
	let address = escapeHtml($w('#addressInput').value);
	let phone = escapeHtml($w('#telephoneInput').value);
	let addtlPhone = escapeHtml($w('#addtlPhoneInput').value);
	let tmDescr = escapeHtml($w('#tmDescrInput').value);
	let country = country_list[$w('#countrySelect').selectedIndex];
	let registNum = escapeHtml($w('#registNumInput').value);
	let registUrl = escapeHtml($w('#registUrlInput').value);
	let trademarkInfo = escapeHtml($w('#trademarkInfoInput').value);
	let document = documentUrls.toString();
	let infringingUrl = escapeHtml($w('#infringingUrlInput').value);
	let infringementDescr = escapeHtml($w('#infringementDescrInput').value);
	let date = $w('#datePicker1').value;
	let eSignature = escapeHtml($w('#signatureInput').value);

	if (checkValidityPage4()) {
		try {
			register({
				"ownerName": ownerName,
				"orgOrClient": orgOrClient,
				"firstName": firstName,
				"lastName": lastName,
				"ownerUrl": ownerUrl,
				"email": email,
				"mailingAddress": address,
				"phone": phone,
				"addtlPhone": addtlPhone,
				"tmDescr": tmDescr,
				"country": country,
				"registNum": registNum,
				"registUrl": registUrl,
				"trademarkInfo": trademarkInfo,
				"document": document,
				"infringingUrl": infringingUrl,
				"infringementDescr": infringementDescr,
				"date": date,
				"eSignature": eSignature
			});
		} catch (error) {
			console.log(error)
		}
		$w("#authorizationGroup").scrollTo();
		$w('#formPage4').collapse();
		$w('#text77').hide();
		$w('#text104').hide();

		$w('#submittedText').expand();
		$w('#text107').expand();
		$w('#submittedText').show();
	} else {
		$w('#text77').show();
	}
}

function uploadFiles(currentButton, uploadUrls) {
	if ($w("#uploadButton" + currentButton).value.length > 0) {
		$w("#uploadButton" + currentButton).startUpload()
			.then((uploadedFile) => {
				console.log('uploaded' + currentButton + uploadedFile.url);
				currentButton++;
				const url = convertDocumentURL(uploadedFile.url)
				uploadUrls.push(url);

				if (currentButton == 4) {
					console.log(uploadUrls)
					submit(uploadUrls);
				} else {
					uploadFiles(currentButton, uploadUrls);
				}
			})
			.catch((uploadError) => {
				$w('#text78').show();
				console.log(`Error: ${uploadError.errorCode}`);
				console.log(uploadError.errorDescription);
			});
	} else {
		currentButton++;
		if (currentButton == 4) {
			submit(uploadUrls);
		} else {
			uploadFiles(currentButton, uploadUrls);
		}
	}
}

export function submitButtonOnClick(event) {
	if (checkValidityPage4()) {
		$w('#text77').hide();
		$w('#text78').hide();
		$w('#submitBtn').disable();
		$w('#backBtn3').disable();
		$w('#submitBtn').label = "Uploading files..."

		uploadFiles(1, new Array());
	} else {
		$w('#text77').show();
	}
}

/*export function uploadTypeOnChange(event, $w) {
	let uploadButtonId = '';
	switch (event.target.id) {
	case 'uploadType1':
		uploadButtonId = 'uploadButton1';
		break;
	case 'uploadType2':
		uploadButtonId = 'uploadButton2';
		break;
	case 'uploadType3':
		uploadButtonId = 'uploadButton3';
	}
	if (event.target.selectedIndex == 0) {
		$w('#' + uploadButtonId).fileType = 'Document';
	} else {
		$w('#' + uploadButtonId).fileType = 'Image';
	}
}*/

$w.onReady(function () {
	let opts = [];
	$w('#text105').expand();
	$w('#text104').hide();

	$w('#text104').collapse();
	$w('#stripOne').collapse();
	$w('#stripTwo').collapse();
	$w('#stripThree').collapse();
	$w('#stripFour').collapse();
	$w('#text35').hide();
	for (var i = 0; i < country_list.length; i++) {
		opts.push({ label: country_list[i], value: '' + i });
	}
	$w('#countrySelect').options = opts;
});

export function radioGroup_click(event, $w) {
	let uploadButtonId = '';
	switch (event.target.id) {
	case 'radioGroup1':
		uploadButtonId = 'uploadButton1';
		$w('#uploadType1').value = null
		break;
	case 'radioGroup2':
		uploadButtonId = 'uploadButton2';
		$w('#uploadType2').value = null
		break;
	case 'radioGroup3':
		uploadButtonId = 'uploadButton3';
		$w('#uploadType3').value = null
	}
	$w('#' + uploadButtonId).fileType = 'Image';
}

export function uploadType_click(event, $w) {
	let uploadButtonId = '';
	switch (event.target.id) {
	case 'uploadType1':
		uploadButtonId = 'uploadButton1';
		$w('#radioGroup1').value = null
		break;
	case 'uploadType2':
		uploadButtonId = 'uploadButton2';
		$w('#radioGroup2').value = null
		break;
	case 'uploadType3':
		uploadButtonId = 'uploadButton3';
		$w('#radioGroup3').value = null
	}
	$w('#' + uploadButtonId).fileType = 'Document';
}

export function convertDocumentURL(URL) {
	if (URL.includes('document')) {
		const convertRegex = new RegExp(/wix:document:\/\/v1\/([^\/]+)\/(.*)$/);
		const matches = URL.match(convertRegex);
		const documentUrl = `docs.wixstatic.com/ugd/${matches[1]}?dn=${matches[2]}`;
		return "https://" + documentUrl
	}
	const convertRegex = new RegExp(/image:\/\/v1\/([^\/]+)\/(.*)$/);
	const matches = URL.match(convertRegex);
	const documentUrl = `static.wixstatic.com/media/${matches[1]}?dn=${matches[2]}`;
	return "https://" + documentUrl
}